export interface Attachable<T> {
  value: T;
  attached: boolean;
}

export function emptyAttachable<T>(): Attachable<T> {
  return {
    value: undefined,
    attached: false,
  } as Attachable<T>;
}
